// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__2TFIl","paymentContainer":"PaymentPage_paymentContainer__uBuwr"};